import React from 'react';
import Select from 'react-select';
import themes from '../../../utils/themes';
import StyledColoredTag from '../styledComponents/StyledColoredTag';
import StyledSelectCss from '../styledComponents/StyledCssSelect';

const StyledSelect = ({
  isMulti,
  options = [],
  value = '',
  onChange,
  disabled = false,
  className = '',
  drop,
  ...props
}) => {
  let newValue = null;
  if (value) {
    newValue = {
      value,
      label: options.find((o) => o.value === value)?.label || value,
    };
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? themes.primaryLight
        : provided.backgroundColor,
      borderRadius: props.borderRadius ? 10 : 8,
      padding: '10px 15px',
      color: themes.textColor,
      cursor: 'pointer',
    }),
    ...(drop === 'up' && {
      menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        top: 'auto',
        bottom: '100%',
      }),
    }),
  };
  const optionalData = (option) => {
    return (
      <div className="d-flex justify-content-between">
        <label>{option?.label}</label>
        {option?.data && (
          <StyledColoredTag variant={option?.color}>
            {option?.data}
          </StyledColoredTag>
        )}
      </div>
    );
  };
  return (
    <StyledSelectCss className="selected__css">
      <Select
        isMulti={isMulti}
        isDisabled={disabled}
        options={options.map((option) => option)}
        getOptionLabel={(option) => optionalData(option)}
        styles={customStyles}
        theme={(theme) => ({
          ...theme,
          borderRadius: props.borderRadius || 10,
          colors: {
            ...theme.colors,
            primary25: themes.lightHover,
            primary50: themes.primaryLight,
          },
        })}
        value={newValue}
        onChange={onChange}
        className={`async-select ${className} ${
          props.isValid ? 'is-valid' : ''
        } ${props.isLightPink ? 'is-light-pink' : ''}${
          props.pay ? ' is-light-pink pay' : ''
        }
        ${props.application ? 'application' : ''}
        ${props.publicForm ? 'publicForm' : ''}
         ${props.isinvalid ? 'is-invalid' : ''} ${disabled ? 'disabled' : ''}`}
        {...props}
      />
    </StyledSelectCss>
  );
};

export default StyledSelect;
